/**
 * Which theme the page is in, for the two views that cannot ask CSS.
 *
 * The map and the altitude profile both draw to a canvas — MapLibre to WebGL,
 * uPlot to Canvas2D — so neither inherits a CSS custom property the way every
 * other component does. Both have to be handed literal colours, which means
 * both have to know the theme, which means the question gets asked twice and
 * belongs in one place.
 *
 * The answer reads the same two signals `globals.css` reads, in the same
 * order: an explicit `data-theme` on `<html>` wins, and otherwise the system
 * preference decides.
 */

export const DARK_QUERY = '(prefers-color-scheme: dark)';

export function prefersDark(doc: Document = document): boolean {
  const override = doc.documentElement.dataset.theme;
  if (override === 'dark') {
    return true;
  }
  if (override === 'light') {
    return false;
  }
  return doc.defaultView?.matchMedia(DARK_QUERY).matches === true;
}
